import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getTallerById } from 'services/servicioGet';
import { TallerBase } from 'utils/models/types';

interface TallerPorIdState {
  taller: TallerBase;
  loadingTaller: boolean;
  errorTaller: string | null;
}

// Estado inicial del slice
const initialState: TallerPorIdState = {
  taller: {
    Id: 0,
    Nombre: '',
    NombreSala: '',
    Docente: '',
    Programa: '',
    ValorCuota: 0,
    AficheUrl: '',
    VisibleEnGrilla: false,
  },
  loadingTaller: false,
  errorTaller: null,
};

export const fetchTallerPorId = createAsyncThunk<
  TallerBase,
  number, // Id del taller
  { rejectValue: string }
>('talleres/fetchTallerPorId', async (id, thunkAPI) => {
  try {
    const response = await getTallerById(id.toString());
    return response;
  } catch (error) {
    return thunkAPI.rejectWithValue('Error al cargar el taller');
  }
});

// Slice de taller por id
const tallerIdSlice = createSlice({
  name: 'taller',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchTallerPorId.pending, state => {
        state.loadingTaller = true;
        state.errorTaller = null;
      })
      .addCase(fetchTallerPorId.fulfilled, (state, action) => {
        state.taller = action.payload;
        state.loadingTaller = false;
      })
      .addCase(fetchTallerPorId.rejected, (state, action) => {
        state.loadingTaller = false;
        state.errorTaller = action.payload as string;
      });
  },
});

export default tallerIdSlice.reducer;
